import api from './api';

export default {
    getProjects() {
        return api.get('/projects');
    },

    getProject(id) {
        return api.get(`/projects/${id}`);
    }
};
